package es.subastia.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import kotlinx.browser.window
import org.w3c.dom.events.Event

@Composable
actual fun BindBackHandler(isEnabled: Boolean, onBack: () -> Unit) {
    // No-op on Web. Navigation is handled by global window.onpopstate in main.kt
}
